import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
    console.error("ErrorBoundary caught an error", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '20px', background: '#fdd', color: '#900', minHeight: '100vh', boxSizing: 'border-box' }}>
          <h2>Oops! The App Crashed!</h2>
          <details style={{ whiteSpace: 'pre-wrap', background: '#fff', padding: '10px', marginTop: '10px', border: '1px solid #ccc' }}>
            <summary style={{fontWeight: 'bold', cursor: 'pointer', marginBottom: '10px'}}>Click here to view error details (Please take a screenshot of this!)</summary>
            {this.state.error && this.state.error.toString()}
            <br />
            {this.state.errorInfo && this.state.errorInfo.componentStack}
          </details>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
